import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { getAuthToken } from '../../utils/auth';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Header from '../Header';
import Footer from '../Footer';
import ReactQuill from 'react-quill';
import logoIcon from '../../img/logo.png';
import 'quill/dist/quill.snow.css';
import { useNavigate } from 'react-router-dom';
import Loader from '../OtherComponents/Loader';
const Base_Url = process.env.REACT_APP_BASE_URL;

const AddPosts = () => {
    const navigate = useNavigate();
    const [formData, setFormData] = useState({ title: '', amount: '', description: '' });
    const [attachment, setAttachment] = useState(null);
    const [attachmentPreview, setAttachmentPreview] = useState(null);
    const [errors, setErrors] = useState({});
    const [loading, setLoading] = useState(false);
    const [postloading, setPostLoading] = useState(true);
    let role = localStorage.getItem('role');

    useEffect(() => {
        if (postloading) return;
        setAttachment(null);
        setFormData({ title: '', amount: '', description: '' });
        setAttachmentPreview(null);
        document.querySelector('input[name="attachment"]').value = null;
    }, [postloading]);


    const modules = {
        toolbar: [
            [{ 'header': '1' }, { 'header': '2' }, { 'font': [] }],
            [{ 'size': ['small', 'medium', 'large', 'huge'] }],
            ['bold', 'italic', 'underline', 'strike', 'blockquote'],
            [{ 'list': 'ordered' }, { 'list': 'bullet' }, { 'indent': '-1' }, { 'indent': '+1' }],
            ['link'],
            [{ 'color': [] }, { 'background': [] }],
            ['clean']
        ],
    };

    const formats = [
        'header', 'font', 'size',
        'bold', 'italic', 'underline', 'strike', 'blockquote',
        'list', 'bullet', 'indent',
        'link', 'color', 'background'
    ];

    const handlePostChange = e => {
        setErrors({ ...errors, [e.target.name]: '' })
        setFormData({ ...formData, [e.target.name]: e.target.value })
    };

    const handleFileChange = e => {
        const file = e.target.files[0];
        setAttachment(file);
        // Create a preview for the image
        if (file) {
            const reader = new FileReader();
            reader.onloadend = () => {
                setAttachmentPreview(reader.result);
            };
            reader.readAsDataURL(file);
        } else {
            setAttachmentPreview(null);
        }
    };

    const handleRemoveAttachment = () => {
        setAttachment(null);
        setAttachmentPreview(null);
    };

    const handleDescriptionChange = value => {
        if (!formData.title || !formData.amount) {
            return; 
        }
        if (errors?.description) {
            setErrors({ ...errors, description: '' })
        }
        setFormData({ ...formData, description: value });
    }

    const validatePostData = () => {
        const errors = {};
        if (!formData.title) errors.title = "Title is required";
        if (!formData.amount) errors.amount = "Amount is required";
        if (!formData.description) errors.description = "Description is required";
        return errors;
    };

    const handlePostSubmit = async e => {
        e.preventDefault();
        const validationErrors = validatePostData();
        if (Object.keys(validationErrors).length > 0) {
            setErrors(validationErrors);
        } else {
            setErrors({});
            try {
                setLoading(true);
                const token = getAuthToken();
                if (token) {
                    const formDataToSend = new FormData();
                    formDataToSend.append('title', formData.title);
                    formDataToSend.append('amount', formData.amount);
                    formDataToSend.append('description', formData.description);
                    if (role === 'admin') {
                        formDataToSend.append('status', 'Approved');
                    }
                    if (attachment) {
                        formDataToSend.append('attachment', attachment);
                    } else {
                        const defaultAttachment = await fetch(logoIcon).then(res => res.blob());
                        formDataToSend.append('attachment', defaultAttachment, 'logo.png');
                    }

                    axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
                    await axios.post(`${Base_Url}/api/posts/user-posts`, formDataToSend, {
                        headers: { 'Content-Type': 'multipart/form-data' }
                    });
                    setFormData({ title: '', amount: '', description: '' });
                    setAttachment(null);
                    setAttachmentPreview(null);
                    setPostLoading(true);
                    navigate('/post/status', { state: { postStatus: true } });
                }
            } catch (err) {
                setErrors({ server: "Failed to submit post. Please try again." });
                toast.error("Failed to submit post. Please try again.");
            } finally {
                setLoading(false);
                setPostLoading(false);
            }
        }
    };

    return (
        <>
            <Header />
            <ToastContainer />
            <div className='topHeading'>
                <h2 className='heading'>Add Post</h2>
            </div>
            {loading ? <Loader /> :
                <div className="form-content">
                    <form onSubmit={handlePostSubmit} className='my-form'>
                        <input
                            type="text"
                            name="title"
                            placeholder="Title"
                            value={formData.title}
                            onChange={handlePostChange}
                            className={`form-control`}
                        />
                        {errors.title && <span className="text-danger">{errors.title}</span>}

                        <input
                            type="text"
                            name="amount"
                            placeholder="Amount"
                            value={formData.amount}
                            onChange={handlePostChange}
                            className={`form-control`}
                            style={{ marginBottom: '-10px' }}
                        />
                        <p><span className='text-danger'>Note* : Please enter amount in canadian dollars</span></p>
                        {errors.amount && <span className="text-danger">{errors.amount}</span>}
                        <ReactQuill
                            value={formData.description}
                            onChange={handleDescriptionChange}
                            modules={modules}
                            formats={formats}
                            className={`form-control`}
                            placeholder="Description"
                        />

                        {errors.description && <span className="text-danger">{errors.description}</span>}

                        <input
                            type="file"
                            name="attachment"
                            onChange={handleFileChange}
                            className={`form-control fileType ${errors.attachment && 'is-invalid'}`}
                        />
                        {attachmentPreview && (
                            <div className="attachment-preview">
                                <img src={attachmentPreview} alt="Attachment Preview" />
                                <button type="button" className="remove-attachment" onClick={handleRemoveAttachment}>X</button>
                            </div>
                        )}
                        {errors.attachment && <span className="text-danger">{errors.attachment}</span>}
                        <p><span className='text-danger'>Note* : The image is for post thumbnail</span></p>
                        <div className='submit-Post-div'>
                            <button type="submit" className="btn btn-primary" disabled={loading}>
                                {!loading && 'Submit'}
                            </button>
                        </div>
                        {errors.server && <span className="text-danger">{errors.server}</span>}
                    </form>
                </div>}
            <Footer />
        </>
    );
};

export default AddPosts;
